import bookingViewList from './List'
import BookingShow from './Show'

const bookingViewResource = {
  list: bookingViewList,
  show: BookingShow,
}

export default bookingViewResource
